import { KyInstance } from 'ky';
import qs from 'qs';

import { CommonQueryParams, CommonResponse } from '../common';
import { Subscription } from './subscription.model';

export async function getSubscriptions(
  httpClient: KyInstance,
  options: CommonQueryParams,
): Promise<CommonResponse<Subscription>> {
  const searchParams = qs.stringify({ populate: '*', ...options });
  const response = await httpClient.get('subscriptions', {
    searchParams,
  });
  return response.json();
}
